<template>
  <div class="aw-join">
    <div class="com-desc-box" v-show="!showDetail">
      <div class="container-center advantage">
        <div class="join-box">
          <div class="m-join-list">
            <ul class="join-list">
              <li
                v-for="(item, index) in joinList"
                :key="index"
                @click="choose(item, index)"
                :class="{ active: key == index }"
              >
                <span class="circle"></span>
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </div>

          <ul class="join-card">
            <li
              v-for="(item, index) in showList"
              :key="index"
              @click="goDetail(item)"
            >
              <p class="join-card-title">{{ item.title }}</p>
              <div class="card-bottom">
                <span class="join-card-desc">{{ item.location }}</span>
                <span class="show-detail">查看详情 →</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="join-detail container-center" v-show="showDetail">
      <p class="rbtn" @click="goIndex">← 全部职位</p>
      <p class="title">{{ currentDetail.title }}</p>
      <p class="area">{{ currentDetail.location }}</p>
      <div class="normal-text">
        岗位职责：<br />
        <p
          v-html="currentDetail.responsibilities"
          style="white-space: pre-wrap"
        ></p>
      </div>
      <div class="normal-text">
        岗位要求：<br />
        <p
          v-html="currentDetail.requirements"
          style="white-space: pre-wrap"
        ></p>
      </div>
    </div>
    <div class="detail-bottom" v-show="showDetail">
      <img src="@/assets/about/icon_HRemail@2x.png" alt="" />
      <div>
        简历投递<br />
        hr@awcloud.com
      </div>
    </div>
  </div>
</template>
<script>
import { queryAppList } from "@/api/common.js";
export default {
  data() {
    return {
      joinList: [
        {
          name: "销售",
          id: "1",
          positions: [
            {
              id: "6666",
              title: "销售经理",
              location: "福州",
              desc: "",
              requirements:
                "1、完成所负责区域内销售任务，包括：合同，回款，项目验收；<br/>2、根据公司业务发展需求，结合目标区域业务特征，制定区域业务销售策略。<br/>3、深刻理解公司产品和解决方案，深刻理解公司与生态伙伴之间的业务模式及价值点，并在实际工作中熟练应用。<br/>4、积极拓展，积极跟进所负责区域的商机，把控风险与投入产出比。根据公司价格及市场策略，结合伙伴业务规则，独立处置报价、合同条款协商及签订事宜，促使商务流程顺利推进，并持续跟进合同、验收、开票、回款等全流程工作。<br/>5、定期组织区域内伙伴力量，进行包括销售、售前、产品等成员在内的沟通与培训，积极沟通协商区域市场活动的举办。<br/>6、与客户保持良好沟通，实时把握客户需求，并提炼市场趋势及需求共性演变，进行分析与整理，及时向公司产品、售前、研发、服务等部门反馈。<br/>7、利用各类资源，发掘潜在客户，并负责客户关系的开发、维护、回访。独立主导从商机挖掘识别、合同谈判、交付转运维及回款的整体流程闭环。<br/>",
              responsibilities:
                "1、工作经验：三年以上IT行业TO B、G销售工作经验（云计算、虚拟化、大数据、安全、存储等领域），厂商、渠道、集成商行业经验；<br/>2、专业：计算机、网络、通信工程等专业优先；<br/>3、踏实，进取，开拓，承压，自我驱动<br/>4、计划能力、沟通能力、组织协调能力、人际交往能力；<br/>5、能熟练使用各种工具，包括Office办公软件、CRM系统等。 <br/>6、熟悉招投标业务基本流程，具备丰富招投标项目经验。<br/>7、性格开朗，积极勤奋，处事客观，善于总结反思。<br/>8、有良好的沟通理解能力，有强烈进取心，有清晰的个人发展规划。<br/>9、有独立开拓市场及客户的能力，良好的自我管理及驱动能力。<br/>10、能承受较大工作压力，可接受频繁短期出差。<br/>",
            },
            {
              id: "7777",
              title: "云计算销售经理",
              location: "北京/深圳等",
              desc: "",
            },
            {
              id: "8888",
              title: "知识产权出版社",
              location: "全国",
              desc: "",
            },
          ],
        },
        {
          name: "培训与教学",
          id: "2",
          positions: [
            {
              id: "6666",
              title: "销售经理",
              location: "福州",
              desc: "",
              requirements:
                "1、完成所负责区域内销售任务，包括：合同，回款，项目验收；<br/>2、根据公司业务发展需求，结合目标区域业务特征，制定区域业务销售策略。<br/>3、深刻理解公司产品和解决方案，深刻理解公司与生态伙伴之间的业务模式及价值点，并在实际工作中熟练应用。<br/>4、积极拓展，积极跟进所负责区域的商机，把控风险与投入产出比。根据公司价格及市场策略，结合伙伴业务规则，独立处置报价、合同条款协商及签订事宜，促使商务流程顺利推进，并持续跟进合同、验收、开票、回款等全流程工作。<br/>5、定期组织区域内伙伴力量，进行包括销售、售前、产品等成员在内的沟通与培训，积极沟通协商区域市场活动的举办。<br/>6、与客户保持良好沟通，实时把握客户需求，并提炼市场趋势及需求共性演变，进行分析与整理，及时向公司产品、售前、研发、服务等部门反馈。<br/>7、利用各类资源，发掘潜在客户，并负责客户关系的开发、维护、回访。独立主导从商机挖掘识别、合同谈判、交付转运维及回款的整体流程闭环。<br/>",
              responsibilities:
                "1、工作经验：三年以上IT行业TO B、G销售工作经验（云计算、虚拟化、大数据、安全、存储等领域），厂商、渠道、集成商行业经验；<br/>2、专业：计算机、网络、通信工程等专业优先；<br/>3、踏实，进取，开拓，承压，自我驱动<br/>4、计划能力、沟通能力、组织协调能力、人际交往能力；<br/>5、能熟练使用各种工具，包括Office办公软件、CRM系统等。 <br/>6、熟悉招投标业务基本流程，具备丰富招投标项目经验。<br/>7、性格开朗，积极勤奋，处事客观，善于总结反思。<br/>8、有良好的沟通理解能力，有强烈进取心，有清晰的个人发展规划。<br/>9、有独立开拓市场及客户的能力，良好的自我管理及驱动能力。<br/>10、能承受较大工作压力，可接受频繁短期出差。<br/>",
            },
          ],
        },
        { name: "实施与运维", id: "3" },
      ],
      key: "0",
      showList: [],
      showDetail: false,
      currentDetail: "",
    };
  },
  methods: {
    choose(val, index) {
      this.key = index;
      this.showList = val.positions;
    },
    goDetail(item) {
      this.showDetail = true;
      this.currentDetail = item;
    },
    goIndex() {
      this.showDetail = false;
    },
    queryList() {
      queryAppList().then((res) => {
        if (res && res.code == 200) {
          let { extendInfo } = res.data;
          extendInfo = JSON.parse(extendInfo);
          this.joinList = extendInfo.job_categories;
          this.showList = this.joinList[0].positions;
        }
      });
    },
  },
  mounted() {
    this.showList = this.joinList[0].positions;
    this.queryList();
  },
};
</script>